<div class="ui-dynamic-datepicker-wrapper">
    <mat-form-field [attr.id]="name" class="mat-form-field-type-ui-date-time-picker" [ngClass]="customClass">
        <mat-label *ngIf="label">{{ label }}</mat-label>
        <ui-date-time-picker
            pickerId="date-time-picker-form-control"
            [touchUi]="touchUi"
            [name]="name"
            [formControl]="control"
            [placeholder]="placeholder || label"
            [value]="control?.value"
            [min]="min"
            [max]="max"
            [required]="required"
            [timelabel]="timeLabel"
        ></ui-date-time-picker>
        <mat-hint>{{ hint }}</mat-hint>
        <mat-error>
            <ng-template
                [ngTemplateOutlet]="errorMessageTemplate"
                [ngTemplateOutletContext]="{ control: control, errors: control?.errors }"
            ></ng-template>
            <ui-validation-message [control]="control"></ui-validation-message>
        </mat-error>
    </mat-form-field>
</div>
